// Brand icons the shared components draw. They live apart from palette.jsx so the first-load
// bundle carries these five, not every page's icons.
export const AttachmentsFolderIcon = ({
  className = "h-[106px] w-[107px]",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="107"
    height="106"
    viewBox="0 0 107 106"
    fill="none"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <circle cx="53.5" cy="53" r="53" fill="#F4F4F4" />
    <path
      opacity="0.2"
      d="M67.125 43.8125V62.1875C67.125 62.3599 67.0911 62.5305 67.0251 62.6898C66.9591 62.849 66.8625 62.9937 66.7406 63.1156C66.6187 63.2375 66.474 63.3341 66.3148 63.4001C66.1555 63.4661 65.9849 63.5 65.8125 63.5H61.875V49.0625L55.3125 42.5H46.125V38.5625C46.125 38.3901 46.1589 38.2195 46.2249 38.0602C46.2909 37.901 46.3875 37.7563 46.5094 37.6344C46.6313 37.5125 46.776 37.4159 46.9352 37.3499C47.0945 37.284 47.2651 37.25 47.4375 37.25L60.5625 37.25L67.125 43.8125Z"
      className="fill-brand"
    />
    <path
      d="M68.0531 42.8844L61.4906 36.3219C61.2445 36.0758 60.9106 35.9375 60.5625 35.9375H47.4375C46.7416 35.9383 46.0743 36.2151 45.5822 36.7072C45.0901 37.1993 44.8133 37.8666 44.8125 38.5625V41.1875H42.1875C41.4916 41.1883 40.8243 41.4651 40.3322 41.9572C39.8401 42.4493 39.5633 43.1166 39.5625 43.8125V67.4375C39.5633 68.1334 39.8401 68.8007 40.3322 69.2928C40.8243 69.7849 41.4916 70.0617 42.1875 70.0625H60.5625C61.2584 70.0617 61.9257 69.7849 62.4178 69.2928C62.9099 68.8007 63.1867 68.1334 63.1875 67.4375V64.8125H65.8125C66.5084 64.8117 67.1757 64.5349 67.6678 64.0428C68.1599 63.5507 68.4367 62.8834 68.4375 62.1875V43.8125C68.4375 43.4644 68.2992 43.1306 68.0531 42.8844ZM60.5625 67.4375H42.1875V43.8125H54.7689L60.5625 49.6062L60.5638 63.4745C60.5636 63.4831 60.5625 63.4914 60.5625 63.5C60.5625 63.5086 60.5636 63.517 60.5638 63.5256L60.5641 67.4374L60.5625 67.4375ZM65.8125 62.1875H63.1875V49.0625C63.1875 48.7144 63.0492 48.3806 62.8031 48.1344L56.2406 41.5719C55.9945 41.3258 55.6606 41.1875 55.3125 41.1875H47.4375V38.5625H60.0189L65.8125 44.3562V62.1875ZM56.625 56.9375C56.625 57.2856 56.4867 57.6194 56.2406 57.8656C55.9944 58.1117 55.6606 58.25 55.3125 58.25H47.4375C47.0894 58.25 46.7556 58.1117 46.5094 57.8656C46.2633 57.6194 46.125 57.2856 46.125 56.9375C46.125 56.5894 46.2633 56.2556 46.5094 56.0094C46.7556 55.7633 47.0894 55.625 47.4375 55.625H55.3125C55.6606 55.625 55.9944 55.7633 56.2406 56.0094C56.4867 56.2556 56.625 56.5894 56.625 56.9375ZM56.625 62.1875C56.625 62.5356 56.4867 62.8694 56.2406 63.1156C55.9944 63.3617 55.6606 63.5 55.3125 63.5H47.4375C47.0894 63.5 46.7556 63.3617 46.5094 63.1156C46.2633 62.8694 46.125 62.5356 46.125 62.1875C46.125 61.8394 46.2633 61.5056 46.5094 61.2594C46.7556 61.0133 47.0894 60.875 47.4375 60.875H55.3125C55.6606 60.875 55.9944 61.0133 56.2406 61.2594C56.4867 61.5056 56.625 61.8394 56.625 62.1875Z"
      className="fill-brand"
    />
  </svg>
);

export const TickCircleIcon = ({ className = "h-4 w-4", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      d="M7.99967 14.6663C11.6663 14.6663 14.6663 11.6663 14.6663 7.99967C14.6663 4.33301 11.6663 1.33301 7.99967 1.33301C4.33301 1.33301 1.33301 4.33301 1.33301 7.99967C1.33301 11.6663 4.33301 14.6663 7.99967 14.6663Z"
      className="fill-brand"
    />
    <path
      d="M5.16699 7.99995L7.05366 9.88661L10.8337 6.11328"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="stroke-brand-tint"
    />
  </svg>
);

export const UnitBuildingIcon = ({
  className = "h-[26px] w-[26px]",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <circle cx="13" cy="13" r="13" className="fill-brand" />
    <path
      d="M19.6192 19.798V7.50612C19.6182 7.19655 19.4657 6.90708 19.211 6.73112C18.9563 6.55516 18.6316 6.51499 18.3417 6.62355L13.6134 8.39383C13.2438 8.53237 12.9992 8.88606 13 9.2808V19.798"
      className="stroke-surface"
    />
    <path
      d="M8.86305 8.21387H10.5178C10.9748 8.21387 11.3453 8.58431 11.3453 9.04127V10.6961H8.03564V9.04127C8.03564 8.58431 8.40608 8.21387 8.86305 8.21387V8.21387Z"
      className="stroke-surface"
    />
    <path d="M9.69049 6.55957V8.21437" className="stroke-surface" />
    <path
      d="M6.38086 19.7977V11.5237C6.38086 11.0667 6.7513 10.6963 7.20826 10.6963H12.1727C12.6296 10.6963 13.0001 11.0667 13.0001 11.5237V19.7977"
      className="stroke-surface"
    />
    <path d="M8.44971 15.6607H10.9319" className="stroke-surface" />
    <path d="M8.44971 15.6607H10.9319" className="stroke-surface" />
    <path d="M8.44971 13.1783H10.9319" className="stroke-surface" />
    <path d="M9.69049 18.5566V19.7974" className="stroke-surface" />
    <path d="M20.3544 19.7974H5.64502" className="stroke-surface" />
    <path d="M15.2061 11.0137V16.8555" className="stroke-surface" />
    <path d="M17.4127 11.0137V16.8555" className="stroke-surface" />
  </svg>
);

export const IconButton3Icon = ({ className = "h-12 w-12", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <rect width="48" height="48" rx="6" fill="#F1F1F2" />
    <rect
      x="14.2998"
      y="14.3"
      width="19.4004"
      height="7.85019"
      rx="1.2"
      className="stroke-primary"
    />
    <rect
      x="14.2998"
      y="25.8497"
      width="19.4004"
      height="7.85019"
      rx="1.2"
      className="stroke-primary"
    />
  </svg>
);

export const IconButtonBlueIcon = ({ className = "h-12 w-12", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <rect width="48" height="48" rx="6" fill="#F1F1F2" />
    <rect
      x="14.2999"
      y="14.3"
      width="7.85018"
      height="7.85019"
      rx="1.2"
      className="stroke-primary"
    />
    <rect
      x="14.2999"
      y="25.8497"
      width="7.85018"
      height="7.85019"
      rx="1.2"
      className="stroke-primary"
    />
    <rect
      x="25.8499"
      y="14.3"
      width="7.85018"
      height="7.85019"
      rx="1.2"
      className="stroke-primary"
    />
    <rect
      x="25.8499"
      y="25.8497"
      width="7.85018"
      height="7.85019"
      rx="1.2"
      className="stroke-primary"
    />
  </svg>
);
